import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { AiFillEdit } from "react-icons/ai";
import { Link } from "react-router-dom";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { getFileIcon } from "utils/utils";
import { getOriginalFileName } from "utils/utils";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function ViewCheckListModal({ open, handleClose, data, onEdit }) {
  if (!data) return null;

  return (
    <BootstrapDialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        <div className="flex items-center justify-between">
          <span className="text-xl font-semibold">Check List Details</span>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        <div className="flex flex-col gap-6">
          {/* Title */}
          <div className="flex flex-col">
            <label className="block uppercase text-app-text-secondary text-xs font-semibold mb-2">
              Title
            </label>
            <div className="text-app-text text-base py-2 px-3 bg-app-surface-muted rounded border border-app-border">
              {data?.key1 || "—"}
            </div>
          </div>

          {/* Description */}
          <div className="flex flex-col">
            <label className="block uppercase text-app-text-secondary text-xs font-semibold mb-2">
              Description
            </label>
            <div className="text-app-text text-base py-2 px-3 bg-app-surface-muted rounded border border-app-border">
              {data?.key2 || "—"}
            </div>
          </div>

          {/* Mandatory Requirements */}
          <div className="flex flex-col">
            <label className="block uppercase text-app-text-secondary text-xs font-semibold mb-2">
              Mandatory Requirements
            </label>
            <div className="text-app-text text-base py-3 px-4 bg-app-surface-muted rounded border border-app-border min-h-[100px]">
              {data?.key3 ? (
                <div
                  dangerouslySetInnerHTML={{ __html: data.key3 }}
                  className="prose prose-sm max-w-none"
                />
              ) : (
                <span className="text-app-text-muted">—</span>
              )}
            </div>
          </div>

          {/* Optional Requirements */}
          <div className="flex flex-col">
            <label className="block uppercase text-app-text-secondary text-xs font-semibold mb-2">
              Optional Requirements
            </label>
            <div className="text-app-text text-base py-3 px-4 bg-app-surface-muted rounded border border-app-border min-h-[100px]">
              {data?.key5 ? (
                <div
                  dangerouslySetInnerHTML={{ __html: data.key5 }}
                  className="prose prose-sm max-w-none"
                />
              ) : (
                <span className="text-app-text-muted">—</span>
              )}
            </div>
          </div>

          {/* Notes */}
          {data?.key6 && (
            <div className="flex flex-col">
              <label className="block uppercase text-app-text-secondary text-xs font-semibold mb-2">
                Notes
              </label>
              <div className="text-app-text text-base py-3 px-4 bg-app-surface-muted rounded border border-app-border min-h-[100px]">
                <div
                  dangerouslySetInnerHTML={{ __html: data.key6 }}
                  className="prose prose-sm max-w-none"
                />
              </div>
            </div>
          )}

          {/* Attachments */}
          {data?.arrKey1 && data?.arrKey1?.length > 0 && (
            <div className="flex flex-col">
              <label className="block uppercase text-app-text-secondary text-xs font-semibold mb-2">
                Attachments
              </label>
              <div className="flex flex-wrap flex-col gap-2">
                {data.arrKey1.map((item, index) => (
                  <Tooltip key={item || index} title={item} arrow>
                    <div className="flex items-center gap-2">
                      <a
                        href={item}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center w-12 h-12 rounded border border-app-border hover:bg-app-surface-hover transition-colors"
                      >
                        {getFileIcon(item)}
                      </a>{" "}
                      <span className="text-sm text-app-text pl-2">
                        {item && getOriginalFileName(item)}
                      </span>
                      <Tooltip title="Download">
                        <Link
                          to={item}
                          download
                          target="_blank"
                          className="text-app-text-secondary hover:text-primary"
                        >
                          <FileDownloadIcon className="text-sm" />
                        </Link>
                      </Tooltip>
                    </div>
                  </Tooltip>
                ))}
              </div>
            </div>
          )}
        </div>
      </DialogContent>
      <DialogActions className="py-2 px-4">
        <Button onClick={handleClose} variant="outlined">
          Close
        </Button>
        {onEdit && (
          <Button onClick={onEdit} variant="contained" startIcon={<AiFillEdit />}>
            Edit
          </Button>
        )}
      </DialogActions>
    </BootstrapDialog>
  );
}
